import React from 'react';

export type ISideMenuProvider = {
    openSideMenu: boolean,            // состояние бокового меню
    drawerwidth: number,              // ширина бокового меню
    handleSideMenuOpen: () => void,   // открытие бокового меню
    handleSideMenuClose: () => void,  // закрытие бокового меню
    handleToggleSideMenu: () => void, // закрытие/открытие бокового меню
}

export const SideMenuContext = React.createContext<ISideMenuProvider | null>(null);

export type ISideMenuProviderProps = {
    defaultDrawerWidth?: number,
}

export const SideMenuProvider = ({ children, defaultDrawerWidth = 290 }: React.PropsWithChildren<ISideMenuProviderProps>): JSX.Element => {
    const [openSideMenu, setOpenSideMenu] = React.useState(false);

    const handleSideMenuOpen = () => {
        setOpenSideMenu(true);
    };

    const handleSideMenuClose = () => {
        setOpenSideMenu(false);
    };

    const handleToggleSideMenu = () => {
        setOpenSideMenu(prev => !prev);
    };

    return (
        <SideMenuContext.Provider
            value={{
                drawerwidth: defaultDrawerWidth,
                openSideMenu,
                handleSideMenuOpen,
                handleSideMenuClose,
                handleToggleSideMenu,
            }}
        >
            {children}
        </SideMenuContext.Provider>
    );
};

export const useSideMenuProvider = (): ISideMenuProvider => {
    const context = React.useContext(SideMenuContext);
    if (context == null) {
        throw new Error('No SideMenuContext provided');
    }

    return context;
};
